import React from 'react'

//import { MenuItem, Select } from "@mui/material"
import { Button, Grid, Input, Form } from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { SPACING } from 'utils'

import { FiltrosContainer } from './FilterTable.styles'
import { SyndicateSearchFormProps } from '../../SearchSyndicate'
import { Control } from 'react-hook-form'

interface FiltrosProps {
  handleSubmit: any
  control: Control<SyndicateSearchFormProps>
  handleSearchSyndicate: (_form?: SyndicateSearchFormProps) => void
  handleClearFilters: () => void
}
export const FilterTable: React.FC<FiltrosProps> = ({
  control,
  handleSubmit,
  handleSearchSyndicate,
  handleClearFilters
}) => {

  function handleSubmitForm(form?: SyndicateSearchFormProps) {
    handleSearchSyndicate(form)
  }

  return (
    <FiltrosContainer>
      <Form onSubmit={handleSubmit(handleSubmitForm)}>
        <Grid
          gridCols="1fr 4fr 1fr 1fr 1fr"
          gridGap={`${SPACING.spacing20}`}
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
        >
          {/*
        <Col>
          <Span text="Tipo" marginBottom={SPACING.spacing5} />
          <Select
            value={tipoState}
            onChange={(e) => handleChangeTipo(e, "tipoState")}
            defaultValue=""
            displayEmpty
            variant="standard"
            label="Tipo"
          >
            <MenuItem value="Acordo">Acordo</MenuItem>
            <MenuItem value="Convenção">Convenção</MenuItem>
            <MenuItem value="">Todos</MenuItem>
          </Select>
        </Col>
        */}
          <Input
            label="CNPJ"
            control={control}
            formValue='cdCnpj'
            mask={['##.###.###/####-##']}
          />
          <Input
            label="Sindicato"
            control={control}
            formValue='nmSindicato'
            placeholder="Nome"
            maxLength={100}
          />
          <div> </div>
          <Button
            marginTop={SPACING.spacing10}
            text="LIMPAR"
            onClick={handleClearFilters}
            variantButton="text"
          />
          <Button
            width={'max-content'}
            endIcon={<MagnifyingGlassIcon />}
            marginTop={SPACING.spacing10}
            text="PESQUISAR"
            type={'submit'}
          />
        </Grid>
      </Form>
    </FiltrosContainer>
  )
}
